import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { primaryCategoryRepository } from '@webapp/platform/organization-management'

const base = ['report-access-secondary-category']

export const reportAccessSecondaryCategoryQueryConfig = {
  list: (primaryCategoryId: number | undefined, params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', primaryCategoryId, params]),
    queryFn: () => {
      if (primaryCategoryId === undefined) {
        throw new Error(
          'Missing primaryCategoryId for the report access secondary category list query. Enable it only once a PrimaryCategory is selected.'
        )
      }
      return primaryCategoryRepository.listSecondaryCategoryConfigs(
        primaryCategoryId,
        params ?? {}
      )
    },
  }),
}
